<template>
  <div class="row">
    <!-- <div class="col-md-5 order-md-1 mb-3">
      <program-admin-tool-section :type="'programs'"/>
    </div> -->
    <div class="col-md-12">
      <div class="lyon-display-medium-24 mb-3">Overview</div>
      <div class="regular-16 mb-3 custom-html-text " v-html = "data.description"/>
      <div class="mb-3" v-if="data.organizers.length > 0">
        <span class="lyon-display-medium-24 mb-3">
          Organizers
        </span>
        <span class="text-center" v-if="canEditCms">
          <a :href="fetchDetailEditUrlWithHashtag(`/programs/${$route.params.id}`, '#representatives')">
          <i class="fa fa-edit edit-icon" v-b-tooltip.hover title="Edit"></i>
        </a>
        </span>
      </div>
      <div class="regular-14 mb-3">
        <organizer
          :organizers="data.organizers"
          :organizers-email-ids="data.organizers_person_email_ids.email_ids"
        />
      </div>
      <div class="lyon-display-medium-24 mb-3" v-if="data.tags.length > 0">
        Keywords
      </div>
      <keyword :tags="data.tags"/>
      <div class="lyon-display-medium-24 mb-3 mt-3" v-if="data.primary_ams.length > 0">
        Primary Mathematics Subject Classification
      </div>
      <div style="overflow-x:auto;">
        <primary-mathematics-subject-classification-view :primary="data.primary_ams"/>
      </div>
      <div class="lyon-display-medium-24 mb-3 mt-3" v-if="data.secondary_ams.length > 0">
        Secondary Mathematics Subject Classification
      </div>
      <div style="overflow-x:auto;">
        <secondary-mathematics-subject-classification-view :secondary="data.secondary_ams"/>
      </div>
    </div>
  </div>
</template>

<script>
import Organizer from '@/components/CommonPages/Organizer.vue'
import Keyword from '@/components/CommonPages/Keyword.vue'
import { mapGetters } from 'vuex'
import PrimaryMathematicsSubjectClassificationView from '@/components/CommonPages/PrimaryMathematicsSubjectClassificationView.vue'
import SecondaryMathematicsSubjectClassificationView from '@/components/CommonPages/SecondaryMathematicsSubjectClassificationView.vue'
import mixin from '@/utils/mixin.js'

export default {
  components: { Organizer, Keyword, PrimaryMathematicsSubjectClassificationView, SecondaryMathematicsSubjectClassificationView },
  name: 'OverviewTabSection',
  props: ['data'],
  mixins: [mixin],
  computed: {
    ...mapGetters(['canEditCms'])
  }
}
</script>
